export const companyHeaders = [
    { text: "거래처명", align: "start", value: "name" },
    { text: "대표자", align: "center", value: "representative" },
    { text: "사업자등록번호", align: "center", value: "registrationNumber" },
    { text: "전화", align: "center", value: "phone" },
    { text: "팩스", align: "center", value: "fax" },
    { text: "주소", align: "start", value: "address" },
    { text: "결제조건", align: "center", value: "paymentTerms" },
    { text: "편집", align: "center", value: "actions", sortable: false },
];
export const personHeaders = [
    { text: "이름", align: "start", value: "name" },
    { text: "이메일", align: "center", value: "email" },
    { text: "전화", align: "center", value: "phone" },
    { text: "편집", align: "center", value: "actions", sortable: false },
];
